// Frame-grab derivative URLs use a STABLE S3 key (`<id>.jpg`) served with a
// 1-year `immutable` cache-control. That's great for never-changing assets, but
// proofs/photos are RE-BAKED in place (same key, new pixels) during grading —
// so the browser keeps serving the stale pre-fix image forever and the gallery
// looks "broken" even after the bake is corrected on the server.
//
// Appending a version token derived from the asset's last bake time makes the
// browser treat each re-bake as a new URL and re-fetch it, while still caching
// hard between bakes. CloudFront returns the (already-overwritten) fresh object.
export function bakeVersion(asset) {
  const sg = asset?.stillGrab || {};
  return sg.finishedAt || sg.requeuedAt || asset?.updatedAt || asset?.updated || 0;
}

// Append `?v=<bakeTime>` to a derivative URL so re-bakes bust the browser cache.
export function bust(url, asset) {
  if (!url) return url;
  const v = bakeVersion(asset);
  if (!v) return url;
  return `${url}${url.includes('?') ? '&' : '?'}v=${v}`;
}
